exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:768px){.customize-servicescardsslider-component>*{padding-right:0!important;padding-left:0!important}}.customize-servicescardsslider-component .well{height:420px}@media (max-width:768px){.customize-servicescardsslider-component .well{padding-right:0!important;padding-left:0!important}}.customize-servicescardsslider-component__title-wrap{padding:0 16px 48px}.customize-servicescardsslider-component__slider{margin-top:-48px}.customize-servicescardsslider-component .slick-track{min-width:9999px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/customize/servicescardsslider.scss
// module id = 1013
// module chunks = 0